import module from 'cheques/module.js'
import template from './template.html'
import { groupBy } from 'lodash'

class ChequesListaComponent {
  constructor ($http) {
    this.$http = $http
    this.idEmpresa = null
    this.idCuenta = null
    this.folio = null
  }

  $onChanges () {
    this.obtenerCheques()
  }

  obtenerCheques () {
    this.data = null

    this.promise = this.$http.get('/api/empresa/cuentabancaria/cheques', {params: {id_empresa: this.idEmpresa, id_cuenta: this.idCuenta}})
      .then((response) => (this.data = groupBy(response.data, ['status'])))
  }
}

module.component('chequesLista', {
  controller: ChequesListaComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cheques/components/lista/component.js